class ScoringIntegrationServiceStore {
  constructor() {
    this.services = [];
    this.initialized = false;
  }

  setServices(data) {
    if (!Array.isArray(data)) return;
    this.services = data;
    this.initialized = true;
  }

  getServices() {
    return this.services;
  }

  isInitialized() {
    return this.initialized;
  }

  getServiceById(id) {
    return this.services.find((s) => s.scoringIntegrationServiceId === id);
  }

  getServiceNames() {
    return this.services.map((s) => s.serviceName);
  }

  clear() {
    this.services = [];
    this.initialized = false;
  }
}

// ✅ SINGLE INSTANCE
export const scoringIntegrationServiceStore =
  new ScoringIntegrationServiceStore();
